module.exports = __webpack_public_path__ + "img/toto_2.11a2b4fc.jpg";